"use strict";

/**
 * A Dummy log
 * @module log
 */
module.exports = {
  debug: function debug(x) {
    return;
  },
  warn: function warn(x) {
    return;
  },
  info: function info(x) {
    return;
  },
  error: function error(x) {
    return;
  },
  success: function success(x) {
    return;
  },
  msg: function msg(x) {
    return;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/rdflib/lib/log.js
// module id = 15
// module chunks = 0